
























































































































import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import InfoTypesNav from "../../InfoTypesNav.vue";
import draggable from "vuedraggable";
import LabelCard from "./LabelCard.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { emptyFn } from "@/fp";
import { UseModal } from "@/components/root/modal";
import CreateCustomLabelTeachModalVue from "./custom-label-teach-modal/CreateCustomLabelTeachModal.vue";
import { EventBus } from "@/eventbus";
import { state } from "./data/state";
import ImproveLabelAccuracyModalVue from "./custom-label-teach-modal/ImproveLabelAccuracyModal.vue";
import { SharedState } from "@/common/state";
import { InfoTypeHelper } from "@/common/models";
import SearchLabelModalVue from "./SearchLabelModal.vue";
import { getInfoType } from "@/common/state/infotypes";
export default Vue.extend({
  components: {
    draggable,
    InfoTypesNav,
    LabelCard,
    SensitivityLabel,
  },
  setup() {
    const {
      info_types,
      selected_info_type,
      set_selected_info_type,
      display_labels,
      selected_l1_id,
      selected_l1_name,
      selected_l1_sensitivity_level,
      selected_l1_sensitivity_name,
      set_selected_l1,
      delete_custom_label,
    } = state;

    const is_selected_l0_personal = computed(() => {
      return (
        selected_info_type.value &&
        selected_info_type.value.id === InfoTypeHelper.REGULATED_ID()
      );
    });

    const has_custom_label_feature = computed(() =>
      SharedState.FeatureHelper.is_enabled("custom_information_type")
    );

    const column_name = (labels_for_level: {
      level: number;
      level_name: string;
      name: string;
    }) => {
      if (!selected_l1_id.value) {
        return labels_for_level.name;
      }
      return labels_for_level.level === 0
        ? "No Sensitivity Subcategories"
        : `${labels_for_level.level_name} Sensitivity Subcategories`;
    };

    const onAdd = async (ev: {
      to: HTMLElement;
      from: HTMLElement;
      item: HTMLElement;
    }) => {
      const from_sensitivity = +(ev.from.dataset.sensitivity as string);
      const to_sensitivity = +(ev.to.dataset.sensitivity as string);
      console.log(
        "from_sensitivity,to_sensitivity",
        from_sensitivity,
        to_sensitivity
      );
      const sensitivity_index = 3 - to_sensitivity;
      if (from_sensitivity != to_sensitivity) {
        const itemId = ev.item.dataset.id as string;
        state.update_label_sensitivity(itemId, to_sensitivity);
        /*
        TODO:
        - optimistic update
        - call the api call
        - on_success : update also the label in the tree using a special function the can traverse the tree
        - on_failure : reverse.
        - set_display_labels();
        */
        //
      }
    };

    const subs = {
      create_custom: emptyFn(),
    };

    const improve_label_accuracy = async (label: {
      id: string;
      name: string;
    }) => {
      await UseModal().show(ImproveLabelAccuracyModalVue, {
        label_id: label.id,
        label_name: label.name,
        is_new: false,
      });
    };

    const show_search_modal = async () => {
      const res = await UseModal().show(SearchLabelModalVue);
      if (res.type == "success") {
        // @ts-ignore
        const { action, label } = res.msg as {
          action: string;
          label: { id: string; name: string };
        };
        switch (action) {
          case "delete_label":
            delete_custom_label(getInfoType(label.id)!);
            break;
          case "improve":
          default:
            improve_label_accuracy(label);
            break;
        }
      }
    };

    onMounted(() => {
      state.init();
      subs.create_custom = EventBus.listen("custom_label", async () => {
        const res = await UseModal().show(CreateCustomLabelTeachModalVue, {
          l0: selected_info_type.value.id,
        });
        if (res.type == "success") {
          // @ts-ignore
          const { label_id, label_name } = res.msg;
          await UseModal().show(ImproveLabelAccuracyModalVue, {
            label_id,
            label_name,
            is_new: true,
          });
        }
      });
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
      state.destroy();
    });

    return {
      onAdd,
      info_types,
      selected_l1_id,
      selected_l1_name,
      selected_l1_sensitivity_level,
      selected_l1_sensitivity_name,
      is_selected_l0_personal,
      selected_info_type,
      set_selected_info_type,
      display_labels,
      set_selected_l1,
      has_custom_label_feature,
      improve_label_accuracy,
      delete_custom_label,
      show_search_modal,
      column_name,
    };
  },
});
